import { GetAccountsPositionsHistoryResponse } from '@goldwasserexchange/actor/rest-services';
import { AccountHistory } from '../../../accounts/history/type';

export const hitHdcToSign = (hitHdc: AccountHistory['HIS_MVT.HIT_HDC'] | GetAccountsPositionsHistoryResponse['HIS_MVT.HIT_HDC']) => ((hitHdc === 'Crédit' || hitHdc === 'Achat')
  ? '+'
  : '-');

export const hitHdcToSignFromLine = (line: AccountHistory | GetAccountsPositionsHistoryResponse | null | undefined) => (line ? hitHdcToSign(line['HIS_MVT.HIT_HDC']) : '');
